import React from 'react'

function ActivityFilter({ title }) {
    return (
        <li>
            <a href="#">{ title }</a>
        </li>
    )
}

export default ActivityFilter
